<template>
  <div class="stock-store-info">
    <van-nav-bar
      title="库存明细"
      left-arrow
      @click-left="onClickLeft"
    />
    <wh-mobile-list ref="listTable" class="main" :extra-params="extraParams" data-src="/api/getRawMaterialsInventoryRecords">
      <template v-slot="{list}">
        <van-swipe-cell v-for="i in list" :key="i.id" :right-width="86">
          <div class="list-item wh-flex-between" @click="edit(i)">
            <div class="wh-flex-center" :style="{backgroundColor:i.recordsQuantity.indexOf('-')<0?'#20CAA0':'#FF6E40'}">
              {{ i.stockType || '添加入库' }}
            </div>
            <div>
              <span>{{ i.supplier||'无供应商' }}</span>
              <span>{{ i.materialName }}</span>
            </div>
            <div :style="{color:i.recordsQuantity.indexOf('-')<0?'#20CAA0':'#FF6E40'}">
              {{ i.recordsQuantity }}
            </div>
            <div>
              <span>负责人：{{ i.staffName }}</span>
              <span>{{ formatTime(i.warehousingTime,'YYYY-MM-DD HH:mm') }}</span>
            </div>
          </div>
          <template #right>
            <van-button square text="删除" style="height:100%;width:86px" type="danger" @click="delRawMaterialsStock(i)" />
          </template>
        </van-swipe-cell>
      </template>
    </wh-mobile-list>
    <stock-store-popup
      :visible.sync="popup.store.visible"
      :form-type="popup.store.formType"
      :init-form-data="popup.store.initFormData"
      @submitFormSuccess="submitFormSuccessFn"
    />
  </div>
</template>
<script>
import api from '@/api'
import { formatTime } from '@/utils/convert/convertTime'
import StockStorePopup from '@/views/StockStore/components/StockStorePopup'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
export default {
  components: { WhMobileList, StockStorePopup },
  data() {
    return {
      popup: {
        store: {
          visible: false,
          formType: 'create',
          initFormData: {}
        }
      }
    }
  },
  computed: {
    extraParams() {
      return {
        stockId: this.$route.params.id
      }
    }
  },
  methods: {
    formatTime,
    onClickLeft() {
      this.$router.go(-1)
    },
    edit(i) {
      if (i.stockType === '使用出库') return
      this.popup.store.formType = 'edit'
      this.popup.store.visible = true
      this.popup.store.initFormData = {
        ...i,
        recordsQuantity: parseInt(i.recordsQuantity)
      }
    },
    submitFormSuccessFn(flag) {
      if (flag) {
        this.$refs.listTable.onRefresh()
      }
    },
    delRawMaterialsStock(i) {
      if (i.stockType === '使用出库') {
        this.$toast.fail('系统出库禁止删除')
        return
      }
      this.$dialog.confirm({
        title: '是否删除'
      })
        .then(() => {
          const params = {
            id: parseInt(i.id)
          }
          api.deleteRawMaterialsStock(params).then(res => {
            if (res.success) {
              this.$refs.listTable.onRefresh()
              this.$toast.success('删除原料库存成功')
            } else {
              this.$toast.success('删除原料库存失败')
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>
<style lang="less" scoped>
.stock-store-info{
  .outclass{
    color: #FF6E40;
  }
  .inclass{
    color: #20CAA0;
  }
  .main{
    padding-top: 6px;
    .list-item{
      height: 62px;
      width: 100%;
      padding: 16px;
      background-color: #fff;
      font-size: 12px;
      margin-bottom: 1px;
      color: #BBBBBB;
      >div:first-child{
        width: 72px;
        border-radius: 2px;
        height: 35px;
        color: #fff;
        background-color: #20CAA0;
      }
      >div:nth-child(2){
        display: flex;
        flex-direction: column;
        width: 60px;
        margin: 0 12px;
        >span:first-child{
          color: #323332;
        }
      }
      >div:nth-child(3){
        font-size: 16px;
        width: 60px;
      }
      >div:last-child{
        display: flex;
        flex-direction: column;
        height: 36px;
        justify-content: space-between;
      }
    }
  }
}
</style>
